export const rutasValidar = [
  '/datos-personales',
  '/tu-futura-tarjeta/mastercard/black',
  '/tu-futura-tarjeta/mastercard/gold',
  '/tu-futura-tarjeta/finalizada/black',
  '/tu-futura-tarjeta/finalizada/gold',
  '/tu-futura-tarjeta/hazte-socio',
  '/tu-futura-tarjeta/dale',
  '/sucursal',
  '/comprobante'
];

export default rutasValidar;
